var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7666 3.86667V6.46667H7.09993V16.8667H9.69993V6.46667H14.0333V3.86667H2.7666ZM19.2333 8.2H11.4333V10.8H14.0333V16.8667H16.6333V10.8H19.2333V8.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 20.8,
    fill: "white",
    transform: "translate(0.599609 0.399994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.9ad5edec61cf99776d33f2bbe54d5c77.svg";
export { ForwardRef as ReactComponent };